import type { GroupByOption } from '@/component/molecules/DualList/types'
import type { Student } from '@/dto'
import { SchoolGrade } from '@/dto/Student/SchoolGrade'

/** 학년별 그룹핑 옵션 */
export const gradeGroupByOption: GroupByOption<Student> = {
  key: 'grade',
  label: '학년',
  getGroup: (student) => student.schoolGrade.flatGrade,
  getGroupLabel: (flatGrade) => SchoolGrade.KO_LABEL[Number(flatGrade) - 1] ?? `${flatGrade}학년`,
}

/**
 * 반별 그룹핑 옵션 생성 함수
 * @param studentLessonClassMap - 학생 ID -> 반 ID[] 매핑 (한 학생이 여러 반에 속할 수 있음)
 * @param getLessonClassName - 반 ID -> 반 이름 변환 함수
 * @param lessonClassOrder - 반 ID 정렬 순서 (GET /lesson-classes 순서)
 */
export const createLessonClassGroupByOption = (
  studentLessonClassMap: Map<Student['id'], number[]>,
  getLessonClassName: (lessonClassId: number | string) => string,
  lessonClassOrder: number[],
): GroupByOption<Student> => ({
  key: 'lesson-class',
  label: '반',
  getGroup: (student) => (studentLessonClassMap.get(student.id) ?? [])[0] as number,
  getGroups: (student) => studentLessonClassMap.get(student.id) ?? [],
  getGroupLabel: (lessonClassId) => getLessonClassName(lessonClassId),
  groupKeyOrder: lessonClassOrder,
})
